export enum OrderItemType {
  SMART_ELECTRICAL_CABINET = 'smart_electrical_cabinet',
  SPINE_MODULE = 'spine_module',
  PLUG_AND_PLAY = 'plug_and_play',
  INSTALLATION_KIT = 'installation_kit',
  VALVE = 'valve',
  RUUVI_TAG = 'ruuvi_tag',
  AURORA = 'aurora'
}
